/** Small version readout for the landing page.
 *
 * Shows the build's version (from the git release tag) and, when the version
 * maps to a GitHub Release or commit, links to it. Kept presentational so the
 * version source stays in version.ts.
 */

import { APP_VERSION, versionHref } from "../version";

interface VersionBadgeProps {
  className?: string;
}

export function VersionBadge({ className = "" }: VersionBadgeProps) {
  const href = versionHref(APP_VERSION);
  const label = `Version ${APP_VERSION}`;
  const classes = `font-utility text-[0.68rem] tabular-nums tracking-wide text-flima-slate/45 ${className}`;

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className={`${classes} underline decoration-flima-slate/20 underline-offset-2 transition-colors hover:text-flima-river focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-flima-river`}
      >
        {APP_VERSION}
      </a>
    );
  }

  return (
    <span aria-label={label} className={classes}>
      {APP_VERSION}
    </span>
  );
}
